import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fd24b37e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "password-validator-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass(['validation-step', _ctx.validClass(_ctx.hasMinCharacters)])
        }, [
            (_openBlock(), _createBlock(_component_FriedIcon, {
                key: _ctx.icon(_ctx.hasMinCharacters),
                icon: _ctx.icon(_ctx.hasMinCharacters)
            }, null, 8, ["icon"])),
            _createElementVNode("span", null, "8 " + _toDisplayString(_ctx.t('characters')), 1)
        ], 2),
        _createElementVNode("div", {
            class: _normalizeClass(['validation-step', _ctx.validClass(_ctx.hasUpperCase)])
        }, [
            (_openBlock(), _createBlock(_component_FriedIcon, {
                key: _ctx.icon(_ctx.hasUpperCase),
                icon: _ctx.icon(_ctx.hasUpperCase)
            }, null, 8, ["icon"])),
            _createElementVNode("span", null, "1 " + _toDisplayString(_ctx.t('uppercase')), 1)
        ], 2),
        _createElementVNode("div", {
            class: _normalizeClass(['validation-step', _ctx.validClass(_ctx.hasLowerCase)])
        }, [
            (_openBlock(), _createBlock(_component_FriedIcon, {
                key: _ctx.icon(_ctx.hasLowerCase),
                icon: _ctx.icon(_ctx.hasLowerCase)
            }, null, 8, ["icon"])),
            _createElementVNode("span", null, "1 " + _toDisplayString(_ctx.t('lowercase')), 1)
        ], 2),
        _createElementVNode("div", {
            class: _normalizeClass(['validation-step', _ctx.validClass(_ctx.hasNumber)])
        }, [
            (_openBlock(), _createBlock(_component_FriedIcon, {
                key: _ctx.icon(_ctx.hasNumber),
                icon: _ctx.icon(_ctx.hasNumber)
            }, null, 8, ["icon"])),
            _createElementVNode("span", null, "1 " + _toDisplayString(_ctx.t('number')), 1)
        ], 2)
    ]));
}
